import axios from 'axios'
import * as types from '@/actions/types'
import constants from '@/constants'
import { convertJsontoFormData } from '@/utils/strings'
import * as loader from '@/actions/loading'

export function getDataPage(slugPage) {
  const params = {
    params: {
      slug: slugPage,
    },
  }
  const content = []
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(constants.urls.API_PAGE, params)
        .then((response) => {
          const data = response.data[0]
          content[slugPage] = data
          dispatch({
            type: types.PAGE_SET_CURRENT,
            setShow: slugPage,
            setType: 'pages',
          })
          dispatch({
            type: types.PAGE_ADD_CONTENT,
            content,
          })
          loader.setReady(true)
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getDataPost(slugPage) {
  const params = {
    params: {
      slug: slugPage,
    },
  }
  const content = []
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(constants.urls.API_POST, params)
        .then((response) => {
          const data = response.data[0]
          content[slugPage] = data
          dispatch({
            type: types.PAGE_SET_CURRENT,
            setShow: slugPage,
            setType: 'posts',
          })
          dispatch({
            type: types.PAGE_ADD_POST,
            content,
          })
          loader.setReady(true)
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
export function getListPost(numItem = 100, paged = 1, categories = '') {
  const params = {
    params: {
      order: 'desc',
      orderby: 'date',
      per_page: numItem,
      page: paged,
      categories,
    },
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(constants.urls.API_POST, params)
        .then((response) => {
          const listPost = []
          listPost.post = response.data.map((value) => {
            const content = []
            content[value.slug] = value
            dispatch({
              type: types.PAGE_ADD_POST,
              content,
            })
            return value.slug
          })
          listPost.postTotal = response.headers['x-wp-total']
          listPost.postPage = Math.ceil(response.headers['x-wp-total'] / numItem)
          dispatch({
            type: types.PAGE_MERGE_LIST_CONTENT,
            list: listPost,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
export function getDataCPT(cpt, slugPage) {
  let params = {}
  if (slugPage !== '') {
    params = {
      params: {
        slug: slugPage,
      },
    }
  }
  const content = []
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_URL}/${cpt}`, params)
        .then((response) => {
          const data = response.data[0]
          content[slugPage] = data
          loader.setReady(true)
          dispatch({
            type: types.PAGE_SET_CURRENT,
            setShow: slugPage,
            setType: 'pages',
          })
          dispatch({
            type: types.PAGE_ADD_CONTENT,
            content,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
export function getListCPT(cpt, num_item = 100, order = 'asc') {
  const params = {
    params: {
      order,
      per_page: num_item,
    },
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_URL}/${cpt}`, params)
        .then((response) => {
          const listPost = []
          listPost[`${cpt}`] = response.data.map((value) => {
            const content = []
            content[value.slug] = value
            dispatch({
              type: types.PAGE_ADD_CONTENT,
              content,
            })
            return value.slug
          })
          dispatch({
            type: types.PAGE_LIST_CONTENT,
            list: listPost,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
export function getThisCPT(cpt, num_item = 100) {
  const params = {
    params: {
      order: 'asc',
      per_page: num_item,
    },
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_URL}/${cpt}`, params)
        .then((response) => {
          const listPost = []
          listPost[`${cpt}`] = response.data.map((value) => {
            const content = []
            content[value.slug] = value
            dispatch({
              type: types.PAGE_ADD_CONTENT,
              content,
            })
            return value.slug
          })
          dispatch({
            type: types.PAGE_LIST_CONTENT,
            list: listPost,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getListTaxonomy(tax, cpt, list) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_URL}/${cpt}?${constants.config.CUSTOM_TAXONOMY_PREFIX}${tax}=${list}`)
        .then((response) => {
          const listPost = []
          listPost[`${constants.config.CUSTOM_TAXONOMY_PREFIX}${tax}`] = response.data.map((value) => {
            const content = []
            content[value.slug] = value
            dispatch({
              type: types.PAGE_ADD_CONTENT,
              content,
            })
            return value.slug
          })
          // dispatch({
          //   type: types.PAGE_LIST_CONTENT,
          //   list: listPost,
          // })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getListTerms(cpt, tax, term) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_URL}/${cpt}?filter[${tax}]=${term}&per_page=100&orderby=menu_order&order=asc`)
        .then((response) => {
          const listPost = []
          listPost[`${term}`] = response.data.map((value) => {
            const content = []
            content[value.slug] = value
            dispatch({
              type: types.PAGE_ADD_CONTENT,
              content,
            })
            return value.slug
          })
          dispatch({
            type: types.PAGE_LIST_CONTENT,
            list: listPost,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getAllTerms(tax, numItem = 100, paged = 1) {
  const params = {
    params: {
      per_page: numItem,
      page: paged,
    },
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_URL}/${tax}`, params)
        .then((response) => {
          const listPost = {}
          listPost[tax] = response.data
          // for (let i = 0; i < response.data.length; i += 1) {
          //   const item = response.data[i]
          //   const { name, slug, link, id, count, cover, cover2 } = item
          //   listPost[tax][item.slug] = { name, slug, link, id, count, cover, cover2 }
          // }
          dispatch({
            type: types.PAGE_LIST_TAXONOMIES,
            list: listPost,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getMedia(numItem = 500, paged = 1) {
  const params = {
    params: {
      per_page: numItem,
      page: paged,
    },
  }
  return (dispatch, getState) => {
  // return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(constants.urls.API_MEDIA, params)
        .then((response) => {
          const media = []
          response.data.forEach((value) => {
            media[value.id] = value
          })
          dispatch({
            type: types.PAGE_ADD_MEDIA,
            data: media,
          })
          const { loading } = getState()
          dispatch({
            type: types.LOADING_SET_INC_STATUS,
            setIncrementalStatus: loading.incremental + 1,
          })
          if (response.headers['x-wp-total'] > numItem * paged) {
            dispatch(getMedia(numItem, paged + 1))
          }
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getDataForm(idForm) {
  const content = []
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_FORM}/${idForm}`)
        .then((response) => {
          const { data } = response
          content[idForm] = data
          dispatch({
            type: types.PAGE_ADD_FORM,
            content,
          })
          const result = {
            status: '',
            message: '',
          }
          dispatch({
            type: types.PAGE_STATUS_FORM,
            result,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
export function sendForm(idForm, params) {
  const headers = { headers: { 'Content-Type': 'multipart/form-data' } }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${constants.urls.API_CF7}/${idForm}/feedback`, convertJsontoFormData(params), headers)
        .then((response) => {
          const { data } = response
          const result = {
            status: 'error',
            message: data.message,
          }
          if (data.status === 'mail_sent') {
            result.status = 'success'
          }
          dispatch({
            type: types.PAGE_STATUS_FORM,
            result,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function sendDataToCallback(value) {
  const headers = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  return () => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${constants.urls.API_MAILCHIMP}email=${value.email}&fields=FNAME&values=${value.name}`, headers)
        .then((response) => {
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function resetForm() {
  return (dispatch) => {
    const result = {
      status: '',
      message: '',
    }
    dispatch({
      type: types.PAGE_STATUS_FORM,
      result,
    })
  }
}

export function setTransition(style) {
  return {
    type: types.PAGE_SET_TRANSITION,
    setTransition: style,
  }
}

export function setShow(bool) {
  return {
    type: types.PAGE_SET_SHOW,
    setShow: bool,
  }
}

export function setCurrent(slug, type) {
  return {
    type: types.PAGE_SET_CURRENT,
    setShow: slug,
    setType: type,
  }
}

export function setArchiveScrollOffset(number) {
  return {
    type: types.PAGE_ARCHIVE_SET_SCROLL_OFFSET,
    scrollOffset: number,
  }
}

export function setSingleScrollOffset(number) {
  return {
    type: types.PAGE_SINGLE_SET_SCROLL_OFFSET,
    scrollOffset: number,
  }
}

export function setIsBack(bool) {
  return {
    type: types.PAGE_SET_IS_BACK,
    isBack: bool,
  }
}
